import {PlugTypeDto} from '../infra/plug/plugType';
import {UserAction} from '../infra/userAction';
import {Opening} from '../infra/opening';
import {Location} from '../location/location';
import {AvailabilityMacroStatus} from '../infra/availabilityMacroStatus';
import {ChargeAreaMarkerDto} from './chargeAreaMarker';
import {StationDto} from '../infra/station/station';

export interface ChargeAreaDetailsMarkerDto extends ChargeAreaMarkerDto {
    '@type': 'chargeAreaDetails';
    address?: Location;
    distanceInKm?: number;
    distanceFromUserInKm?: number;
    supervisedId?: string;
    logoRef?: string;
    brand?: string;
    opening?: Opening;
    plugTypes?: PlugTypeDto[];
    pricingContext?: PricingContextDto;
    /**
     * depends on TA, subscriptionPack and ConnectedUser
     */
    userActions?: UserAction[];
    /**
     * depends on TA, subscriptionPack and ConnectedUser and InfraElement Status on the request moment
     */
    currentUserActions?: UserAction[];
    chargeElemStatuses?: Array<ChargeElemStatusDto>;
    stations?: StationDto[];
}

export interface PricingContextDto {
    pricingCodesBySubscriptionRef?: { [index: string]: string[] };
    otherPricingCodesBySubscriptionRef?: { [index: string]: string[] };
    subscriptionNameByRef?: { [index: string]: string };
}

export enum MapMarkerDetailsLazyCategory {
    /**
     * depends on TA, subscriptionPack and ConnectedUser
     */
    USER_ACTIONS = 'USER_ACTIONS',
    /**
     * depends on TA, subscriptionPack and ConnectedUser and InfraElement Status on the request moment
     */
    CURRENT_USER_ACTIONS = 'CURRENT_USER_ACTIONS',
    PRICING_CONTEXT = 'PRICING_CONTEXT',
    CHARGE_ELEM = 'CHARGE_ELEM',
    STATION = 'STATION'
}

export interface ChargeElemStatusDto {
    available?: number;
    chargeSpeed?: string;
    count?: number;
    status?: AvailabilityMacroStatus;
}
